'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'CountryService', function($scope, $routeParams, $window, CountryService) {
    $scope.countries = [];
    CountryService.api.get({
                               filters: [`'status' EQ 'ENABLED'`],
                               sorts: ['npp:ASC', 'name:ASC'],
                           }, (data) => $scope.countries = data._embedded);
}];
